import axios from "axios";
import store from "@/store";

export default {
    state: {
        userTipTransfer: [],
        transactionHistoryTips: [],
        postTrainerLivestreamAuth: [],
        userLivestreamAuth: [],
        postTrainerEndLivestream: []
    },

    getters: {
        userTipTransfer(state) {
            return state.userTipTransfer;
        },
        transactionHistoryTips(state) {
            return state.transactionHistoryTips;
        },
        trainerLivestreamAuth(state) {
            return state.postTrainerLivestreamAuth;
        },
        userLivestreamAuth(state) {
            return state.userLivestreamAuth;
        },
        trainerEndLivestream(state) {
            return state.postTrainerEndLivestream;
        },
    },

    actions: {
        async postUserTipTransfer({ commit }, payload) {
            const res = await axios.post(`/user/tip-transfer`, payload);

            store.commit("setIsSuccess", res && res.data && res.data.message);

            const data = res && res.data && res.data.data;
            commit("setPostUserTipTransfer", data);
        },

        async postTransactionHistoryTips({ commit }, { payload, query }) {
            commit('loadingStatus', true)
            
            await axios.post("/transaction/history/tips", payload, {
                params: query,
            })
                .then(res => {
                    commit("setTransactionHistoryTips", res.data.data);
                    commit('loadingStatus', false)
                })
                .catch(e => {
                    commit('setTransactionHistoryTips', (e.response && e.response.data) || {})
                    commit('loadingStatus', false)
                })

        },

        async postTrainerLivestreamAuth({ commit }, payload) {
            const res = await axios.post(`trainer/livestream-auth`, payload);

            const data = res && res.data && res.data.data;
            commit("setPostTrainerLivestreamAuth", data);
        },

        async postUserLivestreamAuth({ commit }, payload) {
            const res = await axios.post(`user/livestream-auth`, payload);
            const data = res && res.data;
            commit("setPostUserLivestreamAuth", data);
        },

        async postTrainerEndLivestream({ commit }, payload) {
            const res = await axios.post(`trainer/end-livestream`, payload);

            const data = res && res.data && res.data.data;
            commit("setTrainerEndLivestream", data);
        },
    },

    mutations: {
        setPostUserTipTransfer(state, data) {
            state.userTipTransfer = data;
        },

        setTransactionHistoryTips(state, data) {
            state.transactionHistoryTips = data;
        },

        setPostTrainerLivestreamAuth(state, data) {
            state.postTrainerLivestreamAuth = data;
        },

        setPostUserLivestreamAuth(state, data) {
            state.userLivestreamAuth = data;
        },

        setTrainerEndLivestream(state, data) {
            state.postTrainerEndLivestream = data;
        },
    },
};